export default () => {
	const wavesImage = document.querySelectorAll('.text-image__image');

	if (!wavesImage) return;

	function beforeAfterWindth () {
		wavesImage.forEach(item => {
			const itemHeight = item.clientHeight,
				waveOne = item.querySelector('.image-wave-1'),
				waveTwo = item.querySelector('.image-wave-2'),
				waveOneWidth = (itemHeight / 100) * 17.11712,
				waveTwoWidth = (itemHeight / 100) * 21.08108;



			waveOne.style.width = waveOneWidth + 'px';
			waveTwo.style.width = waveTwoWidth + 'px';
		});
	}

	beforeAfterWindth();

	window.addEventListener('resize', beforeAfterWindth);
}



// WEBPACK FOOTER //
// ./scripts/modules/wave-width.js